export interface IAlertMessage {
    firstButtonLabel: string;
    title: string;
    icon: string;
    text: string;
    acceptFunc: Function;
}
